/**
 * @module      config~utils
 * @since       0.0.1
 * @desc        유틸리티 모듈
 * @author      예장해
 */

import date from "./date";

//const DISPLAY_DATE_FORMAT = 'YYYY-MM-DD HH24:MI:SS',
const DISPLAY_DATE_FORMAT = "YYYY-MM-DD",
  API_DATE_FORMAT = "YYYYMMDDHH24MISS",
  DISPLAY_DATE_FORMAT_EVENT = "MM.DD";

export default {
  cookie: {
    addCookie(key, value, expires) {
      let str = key + "=" + value + "; expires=",
        date;

      str += expires
        ? expires
        : ((date = new Date()),
          date.setFullYear(date.getFullYear() + 10),
          date.toUTCString());

      document.cookie = str;
    },
    getCookie(key) {
      let value = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return value ? value[2] : null;
    },
    removeCookie(key) {
      document.cookie = key + "=; expires=" + new Date().toUTCString();
    },
  },
  date: {
    toFormat(dateObject, format) {
      return date.toFormat(dateObject, format);
    },
    dateToFormat(dateStr, format) {
      let _date,
        _dateFormat = format ? DISPLAY_DATE_FORMAT_EVENT : DISPLAY_DATE_FORMAT;

      switch (true) {
        case typeof dateStr === "string":
          var y = dateStr.substr(0, 4);
          var m = dateStr.substr(4, 2);
          var d = dateStr.substr(6, 2);
          _date = new Date(y, m - 1, d);
          // yyyymmddHHmiss
          //_date.setFullYear(parseInt(dateStr.substring(0, 4)))
          //_date.setMonth(parseInt(dateStr.substring(4, 6)) - 1)
          //_date.setDate(parseInt(dateStr.substring(6, 8)))
          //_date.setHours(parseInt(dateStr.substring(8, 10)))
          //_date.setMinutes(parseInt(dateStr.substring(10, 12)))
          //_date.setSeconds(parseInt(dateStr.substring(12, 14)))
          break;
        case dateStr instanceof Date:
          _date = dateStr;
          break;
      }

      return date.toFormat(_date, _dateFormat);
    },
    toDate(dateStr) {
      let _date = new Date();

      // yyyymmddHHmiss
      _date.setFullYear(parseInt(dateStr.substring(0, 4)));
      _date.setMonth(parseInt(dateStr.substring(4, 6)) - 1);
      _date.setDate(parseInt(dateStr.substring(6, 8)));
      _date.setHours(0);
      _date.setMinutes(0);
      _date.setSeconds(0);
      //            _date.setHours(parseInt(dateStr.substring(8, 10)))
      //            _date.setMinutes(parseInt(dateStr.substring(10, 12)))
      //            _date.setSeconds(parseInt(dateStr.substring(12, 14)))

      return _date;
    },
    toDateForService(dateStr) {
      const year = dateStr.substring(0, 4) || "9999";
      const month = dateStr.substring(4, 6) || "12";
      const day = dateStr.substring(6, 8) || "29";
      const hour = dateStr.substring(8, 10) || "23";
      const minute = dateStr.substring(10, 12) || "59";
      const second = dateStr.substring(12, 14) || "59";
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    isActive(validatedDate, exiredDate) {
      if (!(validatedDate && exiredDate)) return;

      return new Date(validatedDate) < new Date(exiredDate);
    },
    toYYMMDD(dateStr) {
      if (!dateStr || typeof dateStr !== 'string' || dateStr.length < 8) {
        return "";
      }
      const YYMMDD =
        dateStr.substring(0, 4) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(6, 8);
      if (YYMMDD == "9999-12-31") return "";
      return (
        dateStr.substring(0, 4) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(6, 8) +
        " 까지"
      );
    },
    /**
     * 날짜 유효성 검사 함수
     * @param {string} startDate - 시작날짜 (YYYYMMDDHHmmss 형식)
     * @param {string} endDate - 종료날짜 (YYYYMMDDHHmmss 형식)
     * @return {boolean} - startDate <= now <= endDate 관계가 맞으면 true, 아니면 false
     */
    checkValidDate(startDate, endDate) {
      if (!startDate || !endDate) return { isValid: false, message: '날짜를 선택해 주세요.' };

      const now = new Date();
      now.setHours(0, 0, 0, 0);

      // YYYYMMDDHHmmss 형식을 Date 객체로 변환
      const parseDateTime = (dateTimeStr) => {
        const year = parseInt(dateTimeStr.substring(0, 4));
        const month = parseInt(dateTimeStr.substring(4, 6)) - 1; // 월은 0부터 시작
        const day = parseInt(dateTimeStr.substring(6, 8));

        // 시간 부분은 무시하고 날짜만 사용 (00:00:00으로 설정)
        return new Date(year, month, day, 0, 0, 0, 0);
      };

      const startDateTime = parseDateTime(startDate);
      const endDateTime = parseDateTime(endDate);

      // 1. startDate가 now보다 이전인 경우 false
      if (startDateTime < now) return { isValid: false, message: '시작 날짜는 현재 날짜 이후여야 합니다.' };

      // 2. startDate가 endDate보다 이후인 경우 false
      if (startDateTime > endDateTime) return { isValid: false, message: '시작 날짜는 종료 날짜 이전이어야 합니다.' };

      // 3. endDate가 now보다 이전인 경우 false
      if (endDateTime < now) return { isValid: false, message: '종료 날짜는 현재 날짜 이후여야 합니다.' };

      // 4. endDate가 startDate보다 이전인 경우 false (위의 2번과 중복이지만 명시적으로)
      if (endDateTime < startDateTime) return { isValid: false, message: '종료 날짜는 시작 날짜 이후여야 합니다.' };

      // startDate <= now <= endDate 관계가 성립하는 경우 true
      return { isValid: true, message: '유효한 날짜입니다.' };
    },
  },
  hashContent(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) + hash + str.charCodeAt(i);
    }
    return (hash >>> 0).toString(36); // 양수로 변환 후 36진법으로 변환
  },
  setQueryString(parent) {
    const url = new URL(parent || window.location.href);
    const params = new URLSearchParams(url.search);
    console.log(
      "INNER SET QUERY",
      typeof params.get("templateType"),
      typeof params.get("boardIndex"),
      typeof params.get("clientId"),
      typeof params.get("urgentYn"),
      typeof params.get("alarmYn")
    );
    return {
      templateType: Number(params.get("templateType")),
      boardIndex: Number(params.get("boardIndex")),
      clientId: Number(params.get("clientId")),
      urgentYn: params.get("urgentYn") || "N",
      alarmYn: params.get("alarmYn") || "N",
    };
  },
  getEvenSize(targetNumber) {
    return Math.round(targetNumber / 2) * 2 || 2;
  },
  /* 지정 target의 짝수(even) 비율(portion) 값 */
  getEvenSizeByPercent(target, percent) {
    return Math.floor((target * percent) / 100 / 2) * 2;
  },
  getEvenSizeByNumber(target, n) {
    return Math.floor(target / n / 2) * 2;
  },
  /* 지정 target을 n으로 나누었을때 0이 아닌 정수값이 되게 */
  getNSizeByNumber(target, n) {
    return Math.floor(target / n) || 1;
  },

  setClock() {
    const elements = {
      date: document.querySelector(".date_box"),
      time: document.querySelector(".time_box"),
    };

    // DOM 요소가 없으면 early return
    if (!elements.date || !elements.time) {
      console.warn('[setClock] Required DOM elements not found (.date_box, .time_box)');
      return;
    }

    const dayList = ["일", "월", "화", "수", "목", "금", "토"];
    let lastMinute = -1;

    function update() {
      const now = new Date();
      const currentMinute = now.getMinutes();

      if (currentMinute !== lastMinute) {
        const YY = now.getFullYear();
        const MM = String(now.getMonth() + 1).padStart(2, "0");
        const DD = String(now.getDate()).padStart(2, "0");
        const day = dayList[now.getDay()];
        const hh = String(now.getHours()).padStart(2, "0");
        const mm = String(currentMinute).padStart(2, "0");

        elements.date.textContent = `${YY}.${MM}.${DD} (${day})`;
        elements.time.textContent = `${hh}:${mm}`;
        lastMinute = currentMinute;
      }
      requestAnimationFrame(update);
    }

    return update();
  },
};
export const getIntegerSize = (number) => {
  return number === 0 ? 0 : Math.floor(number) || 1;
};

export const getEnables = (obj) => {
  return Object.entries(obj || {})
    .filter(([, config]) => config?.enable);
};

export const getGridArea = (area) => {
  if (!area || !area.start || !area.end) return "";
  const { start, end } = area;
  return {
    gridArea: `${start[0] + 1} / ${start[1] + 1} / ${end[0] + 1} / ${end[1] + 1
      }`,
  };
};

// Absolute + % 기반 영역 스타일 (Grid 대체)
export const getAreaStyle = (area) => {
  if (!area || !area.start || !area.end) return {};
  const { start, end } = area;

  return {
    position: 'absolute',
    left: `${start[1]}%`,
    top: `${start[0]}%`,
    width: `${end[1] - start[1]}%`,
    height: `${end[0] - start[0]}%`,
  };
};

/* app priority group : 1000 */
/* view priority group : 800 */
/* board priority group : 600 */
export const getGridAreaOverlay = (area, overlay, priorityGroup) => {
  if (!area || !area.start || !area.end) return "";
  const { start, end } = area;
  const { priority = 0 } = overlay;
  return {
    gridArea: `${start[0] + 1} / ${start[1] + 1} / ${end[0] + 1} / ${end[1] + 1
      }`,
    zIndex: priorityGroup + priority,
  };
};

export const getFitFontSize = (width, text, maxFontSize) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  let fontSize = 8;
  let flag = true;

  while (flag) {
    ctx.font = `bold ${fontSize}px sans-serif`;
    const textWidth = ctx.measureText(text).width;

    if (fontSize >= maxFontSize) {
      fontSize = maxFontSize;
      break;
    }

    if (textWidth <= width * 0.9) {
      fontSize++;
      continue;
    }

    flag = false;
  }

  return fontSize - 1;
};
